import React, { useEffect, useState } from 'react';
import DailyBalanceChart from '../plan/DailyBalanceChart.js'
import PlanScorecard from '../plan/PlanScorecard.js';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import ActionResult from '../components/ActionResult.js';
import Drawer from '@mui/material/Drawer';

function AlgoQuickManage(props) {

    const [algoInfo, setAlgoInfo] = useState(null);
    const [algoId, setAlgoId] = useState(null);
    const [planId, setPlanId] = useState(null);
    const [currentPerformance, setCurrentPerformance] = useState(null);
    const [newPerformance, setNewPerformance] = useState(null);
    const [newChartData, setNewChartData] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [allocation, setAllocation] = useState(0);
    const [newAllocation, setNewAllocation] = useState(0);
    const [isOrigTestRunning, setIsOrigTestRunning] = useState(false);
    const [isNewTestRunning, setIsNewTestRunning] = useState(false);
    const [result, setResult] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        (async function () {

            setCurrentPerformance(null);
            setNewPerformance(null);
            setAllocations([]);
            setAllocation(0);
            setNewAllocation(0);
            setNewChartData([]);

            setAlgoInfo(null);
            if (algoId) {
                let algo = await (await fetch(`/api/algo?algoId=${algoId}`)).json()
                console.log("algoInfo", algo);
                setAlgoInfo(algo);
            }

            if (planId) {
                let text = await (await fetch(`/api/algos?planId=` + planId + `&years=5`)).json();
                console.log("allocations", text);
                setAllocations(text);

                let allocation = text.find(allocation => allocation.idalgos === algoId);
                if (allocation) {
                    setAllocation(allocation.percentage);
                    setNewAllocation(allocation.percentage);
                } else {
                    setAllocation(0);
                    setNewAllocation(0);
                }
            }
        })();
    }, [algoId, planId]);

    function onOpen() {
        setAlgoId(props.algoId);
        setPlanId(props.planId);
        setDrawerOpen(true);
    }

    function onClose() {
        setAlgoId(null);
        setPlanId(null);
        setDrawerOpen(false);
    }

    function onAllocationIncremented() {
        setNewAllocation(newAllocation + 1);
    }
    function onAllocationDecremented() {
        if (newAllocation <= 0) setNewAllocation(0);
        else setNewAllocation(newAllocation - 1);
    }

    async function runBeforeAfter() {
        if (planId && algoId) {
            setCurrentPerformance(null);
            setNewPerformance(null);
            setIsOrigTestRunning(true);

            console.log("Running original test on for plan " + planId);

            const backtestTradesUrl = `/api/backtestRunComplete?planId=` + planId +
                "&startDate=" + new Date(2014, 0, 1).toLocaleDateString() +
                "&endDate=" + new Date().toLocaleDateString() +
                "&startAmount=100000" +
                "&activeTradesOnly=0" +
                "&liveTradesOnly=0" +
                "&deleteResults=1" +
                "&isOfficial=0";
            let text = await fetch(backtestTradesUrl, { method: 'POST' });
            let results = await text.json();
            console.log("results", results);
            setCurrentPerformance(results);
            setIsOrigTestRunning(false);

            setIsNewTestRunning(true);
            let newPayload = {};
            allocations.forEach(alloc => {
                if (alloc.percentage && Number(alloc.percentage)) {
                    newPayload[Number(alloc.idalgos)] = Number(alloc.percentage);
                }
            })
            newPayload[algoId] = Number(newAllocation);

            const newBacktestUrl = `/api/backtestRunComplete?planId=` + planId +
                "&startDate=" + new Date(2014, 0, 1).toLocaleDateString() +
                "&endDate=" + new Date().toLocaleDateString() +
                "&startAmount=100000" +
                "&activeTradesOnly=0" +
                "&liveTradesOnly=0" +
                "&deleteResults=1" +
                "&allocationStrategyId=4" +
                "&isOfficial=0";
            console.log("Running new test on for plan", newPayload);
            let newResults = await (await fetch(newBacktestUrl, { method: 'POST', body: JSON.stringify(newPayload) })).json();
            console.log("newResults", newResults);
            setNewPerformance(newResults);
            const tempChartData = [];//[["Date", "Account Value", "S&P 500"]]
            newResults.dailyResults.forEach(day => tempChartData.push([new Date(day.date), day.total, day.baseline]))
            setNewChartData(tempChartData);

            setIsNewTestRunning(false);
        }
    }

    async function saveNewAllocation() {
        const url = `/api/updatePlanAlgoAllocation?planId=` + planId + `&algoId=` + algoId + `&percentage=` + newAllocation;
        await (await fetch(url, { method: 'POST' })).json();
        setResult({ success: algoId + " updated to " + newAllocation + " for plan " + planId });
    }

    return (
        <>{props.role === 3 ?
            <>
                <Link className="tooltip-link" onClick={() => onOpen()}>🟠</Link>
                <Drawer
                    anchor={'bottom'}
                    open={drawerOpen}
                    onClose={() => onClose()}
                >
                    <div style={{ width: '100%', padding: '20px' }}>
                        <center>
                            <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                            <br></br>

                            {algoInfo ?
                                <div>
                                    <b>
                                        {algoInfo && algoInfo.algo && algoInfo.algo.length ? algoInfo.algo[0].display_name : "Loading..."}
                                    </b>
                                    <br></br>
                                    <>
                                        Current: {allocation}%
                                        &nbsp; Updated: <Link className="plus-minus-button" onClick={() => onAllocationDecremented()}>⬇️</Link>
                                        &nbsp;<input type="text" size="4" value={newAllocation} onChange={(e) => setNewAllocation(e.target.value)} />
                                        &nbsp;<Link className="plus-minus-button" onClick={() => onAllocationIncremented()}>⬆️</Link>
                                        &nbsp;<button class="btn btn-primary" onClick={() => runBeforeAfter()} type="button">Run Test</button>
                                    </>
                                    <br></br>
                                    <button class="btn btn-primary" onClick={() => saveNewAllocation()} type="button">Save</button>
                                    <br></br>

                                    {isOrigTestRunning || isNewTestRunning || currentPerformance || newPerformance ?
                                        <>
                                            <table width={600}>
                                                <tr>
                                                    <th>Before</th>
                                                    <th width="50%">After</th>
                                                </tr>
                                                <tr style={{ backgroundColor: 'transparent' }}>
                                                    <td>
                                                        {isOrigTestRunning ?
                                                            <CircularProgress />
                                                            : currentPerformance ?
                                                                <PlanScorecard backtestResults={currentPerformance}></PlanScorecard>
                                                                :
                                                                <>None</>
                                                        }
                                                    </td>
                                                    <td>
                                                        {isNewTestRunning ?
                                                            <CircularProgress />
                                                            : newPerformance ?
                                                                <PlanScorecard backtestResults={newPerformance}></PlanScorecard>
                                                                :
                                                                <>None</>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr style={{ backgroundColor: 'transparent' }}>
                                                    <td colSpan={2}>
                                                        <DailyBalanceChart defaultToYtd={false} defaultToSyncValues={false} backtestResults={newPerformance} chartData={newChartData} hideAllocationChart={true} hideChartSummary={true}></DailyBalanceChart>
                                                    </td>
                                                </tr>
                                            </table>
                                            <br></br>
                                        </>
                                        : null}

                                </div>
                                : null}
                        </center>
                        <br></br>
                        <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    </div>
                </Drawer>
            </>
            : null}

            <ActionResult result={result} />
        </>
    )
}

export default AlgoQuickManage;